import * as React from "react";
import { IconProps } from "./types";

const HandsClapping = ({
  className,
  width = 24,
  height = 24,
  strokeWidth,
}: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    strokeWidth={strokeWidth}
    viewBox="0 -0.5 17 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.595 11.464a1.65 1.65 0 0 1 2.382-2.283l3.043 3.176a.55.55 0 1 1-.794.762L2.183 9.942a.55.55 0 1 0-.794.761l3.044 3.177a.55.55 0 1 1-.794.761L.595 11.464Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.422 9.148a1.65 1.65 0 1 1 2.383-2.283l3.043 3.177a.55.55 0 1 1-.794.761L3.01 7.625a.55.55 0 0 0-.794.761l3.044 3.177a.55.55 0 1 1-.794.761L1.422 9.148Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.772 8.42a1.65 1.65 0 1 1 2.382-2.282l3.428 3.576a.55.55 0 1 1-.795.761L5.36 6.898a.55.55 0 1 0-.794.761l3.044 3.176a.55.55 0 1 1-.795.76L3.772 8.42Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.264 8.197a1.755 1.755 0 0 1 3.311-1.091l.825 1.793a.551.551 0 0 1-1.001.459l-.823-1.794a.655.655 0 0 0-1.236.407l.435 2.08a.55.55 0 1 1-1.076.225l-.435-2.079Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.164 15.488a.551.551 0 0 1 .778.017l2.652 2.767c.394.41.867.737 1.39.96l.038.017a4.076 4.076 0 0 0 3.3-.047l.153-.07a5.416 5.416 0 0 0 1.488-1.013l.14-.135a4.076 4.076 0 0 0 .966-4.455l-1.676-4.191a.549.549 0 0 1 .728-.71.55.55 0 0 1 .294.3l1.675 4.192a5.177 5.177 0 0 1-1.226 5.658l-.14.134a6.533 6.533 0 0 1-1.79 1.22l-.152.07a5.174 5.174 0 0 1-4.191.059l-.038-.017a5.311 5.311 0 0 1-1.753-1.21l-2.65-2.768a.55.55 0 0 1 .014-.778Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.528 14.575a1.65 1.65 0 0 1 2.382-2.284l1.523 1.589a.55.55 0 1 1-.794.761l-1.523-1.588a.548.548 0 0 0-.9.159.55.55 0 0 0 .106.602l3.045 3.177a.55.55 0 1 1-.795.76L.528 14.576Zm5.595-6.886a1.65 1.65 0 1 1 2.383-2.283l.532.557a.55.55 0 1 1-.794.76l-.532-.555a.55.55 0 0 0-.794.76l1.52 1.59a.55.55 0 1 1-.793.76L6.123 7.69Zm4.659-.107a1.684 1.684 0 0 1 3.113-1.278l.857 1.867a.551.551 0 0 1-1.001.458l-.856-1.866a.584.584 0 0 0-1.08.443l.674 1.851a.55.55 0 1 1-1.034.377l-.673-1.852Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.052 7.892a.55.55 0 0 1 .715.306l1.674 4.191a5.176 5.176 0 0 1-1.225 5.66l-.111.107c-.543.52-1.17.947-1.854 1.261l-.134.062A7.636 7.636 0 0 1 12 19.89l-1.27.359a.55.55 0 0 1-.298-1.06l1.268-.357c.328-.092.65-.21.957-.352l.135-.063a5.663 5.663 0 0 0 1.552-1.056l.112-.106a4.076 4.076 0 0 0 .965-4.456l-1.676-4.192a.55.55 0 0 1 .307-.715ZM1.642 1.195a.55.55 0 0 1 .763.146l1.327 1.956a.55.55 0 0 1-.91.617L1.495 1.959a.55.55 0 0 1 .147-.764Zm8.808-.035a.55.55 0 0 0-.74.24l-.997 1.955a.55.55 0 1 0 .979.5L10.69 1.9a.55.55 0 0 0-.24-.74ZM6.14.55a.55.55 0 0 1 .55.55v1.955a.55.55 0 0 1-1.1 0V1.1a.55.55 0 0 1 .55-.55Z"
      fill="inherit"
    />
  </svg>
);

export default HandsClapping;
